<script>

	import './style.scss'

	export default {
		name: 'sample-questions'
	}

</script>

<template>
	<div class='sample-questions'>
		<header>
			Sample Programming Interview Question
		</header>
		<div class='question'>
			<div class='asked-by'>
				Asked by <img src='~@/assets/svg/companies/amazon.svg' class='stripe'>
			</div>
			<div class='question-container'>
				<div class='question-content'>
					<p>
						There's a staircase with N steps, and you can climb 1 or 2 steps at a time.
						Given N, write a function that returns the number of unique ways you can climb the staircase.
						The order of the steps matters.
					</p>
					<p>
						For example, if N is 4, then there are 5 unique ways:
					</p>
						<ul>
							<li>1, 1, 1, 1</li>
							<li>2, 1, 1</li>
							<li>1, 2, 1</li>
							<li>1, 1, 2</li>
							<li>2, 2</li>
						</ul>
					<p>
						What if, instead of being able to climb 1 or 2 steps at a time, you could climb any number
						from a set of positive integers X? For example, if X = {1, 3, 5}, you could climb 1, 3, or 5
						steps at a time. Generalize your function to take in X.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/SampleQuestions/SampleQuestions.vue